import {css} from "styled-components";

const ccnqBase = {
  title_font: 'Barlow',
  title_weight: 700,
  title_margin_left: true,
  subtitle_font: 'Barlow',
  subtitle_weight: '600',
  text_font: 'Barlow',
  text_weight: 400,
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_radius: 100,
  text_size: 18,
  subtitle_size: 28,
  subtitleH3_font_size: 23,
  title_size: 33,
  token_width: 79,
  title_lineheight: 30,
}

const ccnqPanoramic = {
  ...ccnqBase,
  body_background_color: '#192938',
  button_color: '#E98A33',
  button_hover_text_color: '#192938',
  button_text_color: '#192938',
  button_outlined_hover_text_color: '#192938',
  button_outlined_border_color: '#E98A33',
  button_outlined_hover_border_color: '#E98A33',
  custom_alternate_button: css`
    color: #192938;
  `
}

export const ccnqPanoramicW = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_panoramic.png',
  token_url: 'ccnq/ccnq_panoramic_w.png'
}
export const ccnqPanoramicS = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_panoramic.png',
  token_url: 'ccnq/ccnq_panoramic_s.png'
}
export const ccnqPanoramicO = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_panoramic.png',
  token_url: 'ccnq/ccnq_panoramic_o.png'
}
export const ccnqPanoramicN = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_panoramic.png',
  token_url: 'ccnq/ccnq_panoramic_n.png'
}
export const ccnqPanoramicE = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_panoramic.png',
  token_url: 'ccnq/ccnq_panoramic_e.png'
}
export const ccnqPanoramicLight = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_dark.png',
  token_url: 'ccnq/ccnq_light.png'
}
export const ccnqPanoramicDark = {
  ...ccnqPanoramic,
  logo_image_url: 'ccnq/ccnq_dark.png',
  token_url: 'ccnq/ccnq_dark.png'
}

const ccnqPerspective = {
  ...ccnqBase,
  body_background_color: '#00AAA8',
  button_color: '#00AAA8',
  button_hover_text_color: '#00AAA8',
  button_outlined_border_color: '#00AAA8',
  button_outlined_hover_border_color: '#00AAA8',
  button_text_color: '#192938',
  button_outlined_hover_text_color: '#192938',
  custom_alternate_button: css`
    color: #192938;
  `
}

export const ccnqPerspectiveW = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_perspective.png',
  token_url: 'ccnq/ccnq_perspective_w.png'
}
export const ccnqPerspectiveS = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_perspective.png',
  token_url: 'ccnq/ccnq_perspective_s.png'
}
export const ccnqPerspectiveO = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_perspective.png',
  token_url: 'ccnq/ccnq_perspective_o.png'
}
export const ccnqPerspectiveN = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_perspective.png',
  token_url: 'ccnq/ccnq_perspective_n.png'
}
export const ccnqPerspectiveE = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_perspective.png',
  token_url: 'ccnq/ccnq_perspective_e.png'
}
export const ccnqPerspectiveLight = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_light.png',
  token_url: 'ccnq/ccnq_light.png'
}
export const ccnqPerspectiveDark = {
  ...ccnqPerspective,
  logo_image_url: 'ccnq/ccnq_light.png',
  token_url: 'ccnq/ccnq_dark.png'
}
